module.exports = __webpack_public_path__ + "img/习城乡.921df48f.png";